import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const state = {
  flags: {
    showHeadingsAndFilters: false,
    goClicked: false,
    loadingSPData: false,
    showFootnotes: true,
    generatingPdf: false,
  },
  GSGo: {
    locationId: '',
    location: '',
    categoryId: '',
    category: '',
  },
  maxPanelCount: 8,
  indicators: [],
  spData: [],
  panels: {},
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};



// WEBPACK FOOTER //
// ./src/store/modules/SP/index.js